import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import IntroAnimation from './components/IntroAnimation';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Process from './pages/Process';
import Faq from './pages/Faq';
import BodyKits from './pages/BodyKits';
import Contact from './pages/Contact';
import ProductDetail from './pages/ProductDetail';
import Collection from './pages/Collection';
import Search from './pages/Search';
import Terms from './pages/Terms';
import Palettes from './pages/Palettes';
import BrandModels from './pages/BrandModels';
import BrandHub from './pages/BrandHub';
import ShopByVehicle from './pages/ShopByVehicle';
import Wheels from './pages/Wheels';
import ThankYou from './pages/ThankYou';
import Inquiry from './pages/Inquiry';
import Checkout from './pages/Checkout';
import Pay from './pages/Pay';
import HeroOptions from './pages/HeroOptions';
import ShopifyRedirect from './pages/ShopifyRedirect';
import AdminEmails from './pages/AdminEmails';
import Admin from './pages/admin/Admin';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';
import RouteAwareSeo from './components/RouteAwareSeo';
import GoogleAnalytics from './components/GoogleAnalytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const isAdminPath = (p) => p.startsWith('/admin') || p.startsWith('/pay');
const StoreHeader = () => (isAdminPath(useLocation().pathname) ? null : <Header />);
const StoreChrome = () => (isAdminPath(useLocation().pathname) ? null : (<><Footer /><CartDrawer /></>));
const StoreIntro = () => (isAdminPath(useLocation().pathname) ? null : <IntroAnimation />);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <RouteAwareSeo />
          <GoogleAnalytics />
          <ScrollToTop />
          <StoreIntro />
          <StoreHeader />
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<ShopByVehicle />} />
              <Route path="/shop/:brand" element={<BrandModels />} />
              <Route path="/brands/:brandSlug" element={<BrandHub />} />
              <Route path="/wheels" element={<Wheels />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/process" element={<Process />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/body-kits" element={<BodyKits />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/search" element={<Search />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/palettes" element={<Palettes />} />
              <Route path="/collections/:collectionId" element={<Collection />} />
              <Route path="/collection/:collectionId" element={<Collection />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/inquiry" element={<Inquiry />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/pay/:token" element={<Pay />} />
              <Route path="/hero-options" element={<HeroOptions />} />
              <Route path="/admin/emails" element={<AdminEmails />} />
              <Route path="/admin/catalog" element={<Admin />} />
              {/* Legacy Shopify URLs — redirect to the new product slug so we
                  keep the SEO authority from years of indexed pages. */}
              <Route path="/products/:handle" element={<ShopifyRedirect />} />
              <Route path="/pages/about" element={<Navigate to="/about" replace />} />
              <Route path="/pages/contact" element={<Navigate to="/contact" replace />} />
              <Route path="/pages/terms-and-conditions" element={<Navigate to="/terms" replace />} />
              <Route path="/terms-and-conditions" element={<Navigate to="/terms" replace />} />
              <Route path="/cart" element={<Navigate to="/" replace />} />
            </Routes>
            <StoreChrome />
            <Toaster />
          </CartProvider>
        </BrowserRouter>
    </div>
  );
}

export default App;
